<template>
  <div class="content">
<!--    <div class="tit">杭州电猪科技</div>-->
    <div class="main">
      <div class="naver">
        <div class="navertit">{{ title }}</div>
        <div class="word">
          {{ content }}
        </div>
        <div class="contentimgbox">
<!--          :src="video"-->
          <video controls style="width: 100%;" autoplay loop muted>
          <source src="https://image.fangpinyouxuan.com/advertise/a1.mp4">
<!--            <source src="https://vd2.bdstatic.com/mda-jmtd4ap95bgdbgkq/sc/mda-jmtd4ap95bgdbgkq.mp4?v_from_s=sz_haokan_4469&auth_key=1623138022-0-0-b6d0122ca94955a7839512b4e50b41af&bcevod_channel=searchbox_feed&pd=1&pt=3&abtest=3000156_2" >-->
          </video>
        </div>
        <div class="navertit">你将得到哪些权益？</div>
        <div class="naverRights" v-if="nowlist==true">
          <div v-for="(item,index) in Rights.slice(0,4)" :key="index" class="tip">
<!--            <img :src="item.img_create" alt="">-->
            <span v-html="item"></span>
          </div>
        </div>
        <div class="naverRights" v-else>
          <div v-for="(item,index) in Rights" :key="index" class="tip">
            <span v-html="item"></span>
<!--            <img :src="item.img_create" alt="">-->
<!--            <span>{{ item.word }}</span>-->
          </div>
        </div>
        <div :class="nowlist==true?'lookmorered':'lookmoregrey'" @click="lookmore">
            查看更多
        </div>
        <div class="navertit">客户评价</div>
        <div class="evaluateline" v-for="(item,index) in evaluate" :key="index" >
            <div class="top">
              <div class="headerpng"><img :src="item.headIcon" alt="" class="hepng"></div>
              <div class="headerintro">
                <p class="name">{{ item.name }}</p>
                <p class="detail">
                  <span>{{item.address}}｜{{item.area}}m²</span>
                  <span>｜{{ item.house_type }}</span>
                </p>
              </div>
            </div>
            <div class="bottomss">
              {{ item.evaluate }}
            </div>
        </div>
        <div class="navertit">合作/招商案例</div>
        <div class="swp" >
          <van-swipe :autoplay="3000">
            <van-swipe-item v-for="(item,index) in houses" :key="index">
              <img v-lazy="item" />
            </van-swipe-item>
          </van-swipe>
        </div>
        <div class="navertit">分享收益</div>
        <div class="naverRights">
           <div v-for="(item,index) in profit" :key="index" class="tips">
             <span class="circle"></span>
             <span class="textword" v-html="item"></span>
           </div>
        </div>
      </div>
    </div>
    <div class="blackmodel">
       <div class="code1">联系我们</div>
       <div class="code2">0571-8781-3887</div>
       <div class="code3">公司地址：{{ companyAddress }}</div>
       <div class="code4">邮箱：{{ companyEmail }}</div>
      <div class="blackcode">
        <div class="codeline">
          <p class="linpng"><img src="../../assets/img/gongzhong.png" alt="" class="codepng"></p>
          <p class="linword">扫码关注公众号</p>
        </div>
        <div class="codeline">
          <p class="linpng"><img src="../../assets/img/downapp.png" alt="" class="codepng"></p>
          <p class="linword">扫码下载APP</p>
        </div>
      </div>
      <div class="bot">
        <p>Copyright@2019-2021 杭州电猪科技有限公司</p>
        <p>惠利购房者，赋能创业者；让人人都有一个温暖的家</p>
      </div>
    </div>
    <div class="bottom">
      <div class="bottomleft">
        <div class="bottombox">
          <a href="tel:0571-8781-3887">
          <p class="b_top"><img src="../../assets/img/call.png" alt="" class="b_png"></p>
          <p class="b_bottom">电话</p>
          </a>
        </div>
        <div class="bottombox" @click="looking">
          <p class="b_top"><img src="../../assets/img/hua.png" alt="" class="b_png"></p>
          <p class="b_bottom">关注</p>
        </div>
        <div class="bottombox" @click="looking2">
          <p class="b_top"><img src="../../assets/img/wechart.png" alt="" class="b_png"></p>
          <p class="b_bottom">进群</p>
        </div>
      </div>
      <a href="http://fangpinyouxuan.com/d.html"><div class="joinbtn">进入小程序</div></a>
    </div>
    <div class="mask" v-show="mask"></div>
    <div class="box" v-show="box">
        <div class="tix">长按识别关注公众号</div>
         <img src="../../assets/img/cancle.png" alt="" class="close" @click="closebox">
        <div style="margin: 0 auto;width: 200px;">
         <img src="../../assets/img/gongzhong.png" alt="" class="codepng">
        </div>
    </div>
    <div class="box" v-show="box2">
      <div class="tix">长按识别添加咨询顾问</div>
      <img src="../../assets/img/cancle.png" alt="" class="close" @click="closebox2">
      <div style="margin: 0 auto;width: 200px;">
        <img src="../../assets/img/weixin.png" alt="" class="codepng">
      </div>
    </div>
  </div>
</template>

<script>
import {
  clos_encryptDes,
  clos_encryptDes1,
  clos_encryptDes2,
  clos_encryptDesForApp,
  time as initTime,
} from "@/encryption";
import {Toast} from "vant";
import {getLandingpage} from "api/ajax";
export default {
name: "Landingpage",
  data(){
   return{
     autoplay:true,
     title:'',
     content:'',
     video:'',
     companyAddress:'',
     companyEmail:'',
     mask:false,
     box:false,
     box2:false,


     nowlist:true,
     Rights:[],
     evaluate:[],//客户评价
     houses:[],//合作招商轮播
     profit:[],//分享收益
   }
  },
  created() {
  this.submit()
  },
  methods:{
    handleClick() {
      this.$parent.showDownload = true;
    },
    looking(){
      this.box=true
      this.mask=true
    },
    looking2(){
      this.box2=true
      this.mask=true
    },
    closebox(){
      this.box=false
      this.mask=false
    },
    closebox2(){
      this.box2=false
      this.mask=false
    },
    lookmore(){
      if(this.nowlist==false){
        this.nowlist=true
      }else{
        this.nowlist=false
      }
    },
    async submit() {
      let time = this.time()
      let args = {
        action: "propaganda.getPropaganda",
        timestamp:time
      };
      let response = await getLandingpage(args);
      let {statusCode, success} = response
      if (statusCode === 201 && success== true) {
        // Toast.success('客户信息提交成功');
        console.log(response,'ss')
        this.title=response.data.title
        this.content=response.data.content
        this.evaluate=response.data.customerEvaluations
        this.houses=response.data.investmentCasesList
        this.profit=response.data.shareProfitList
        this.Rights=response.data.getBenefitsList
        this.video=response.data.video
        this.companyAddress=response.data.companyAddress
        this.companyEmail=response.data.companyEmail
      } else {
        // Toast.fail('客户信息提交失败');
      }
    }
  },
  mounted() {
  }
}
</script>

<style scoped lang="scss">
  .content{
    //padding: 16px;
    position: relative;
    .mask{
      position: absolute;
      left: 0;
      bottom: 0;
      width: 100%;
      min-height:100%;
      background: #000000;
      opacity: 0.7;
      z-index: 99;
    }
    .box{
      position: fixed;
      left:17.5%;
      top: 30%;
      width:220px;
      height: 250px;
      background: #FFFFFF;
      z-index:999;
      padding: 12px;
      margin: 10px auto;
      .tix{
        text-align: center;
        height: 34px;
        font-size: 18px;
        font-family: PingFang SC;
        font-weight: 400;
        color: #141414;
        line-height: 34px;
      }
      .close{
        width: 20px;
        height: 20px;
        position: absolute;
        right: 10px;
        top: 15px;
      }
      .codepng{
        width:200px;
        height: 200px;

      }
    }
    .tit{
      font-size: 20px;
      font-weight: bold;
      color: #333333;
      text-align: center;
      height:60px;
      line-height: 60px;
      background: #F6F6F6;
    }
    .main{
      padding: 10px 20px 60px;
      .naver{
        .navertit{
          height: 48px;
          font-size: 19px;
          font-family: PingFang SC;
          font-weight: 600;
          color: #24262D;
          line-height: 48px;
        }
        .word{
          font-size: 15px;
          font-family: PingFang SC;
          font-weight: 400;
          color: #141414;
          line-height: 26px;
          text-indent: 4px;
        }
        .contentimgbox{
          .contentimg{
            width: 100%;
            height: 230px;
          }
        }
        .naverRights{
          .tip{
            height: 40px;
            line-height: 40px;
            display: flex;
            justify-content: flex-start;
            img{
              width: 26px;
              height: 26px;
              vertical-align: middle;
              margin-top: 7px;
            }
            span{
              font-size: 14px;
              font-family: PingFang SC;
              font-weight: 400;
              color: #141414;
              margin-left: 10px;
            }
          }
          .tips{
            height: 40px;
            //line-height: 40px;
            display: flex;
            justify-content: flex-start;
            .circle{
              width: 8px;
              height: 4px;
              background: #F8242C;
              border-radius: 2px;
              margin-top: 18px;
            }
            .textword{
              font-size: 14px;
              font-family: PingFang SC;
              font-weight: 400;
              color: #141414;
              margin-left: 18px;
              margin-top: 10px;
            }
          }
        }
        .swp{
          box-sizing: border-box;
          .van-swipe{
            width: 100%;
            .van-swipe__track{
              width: 100%;
              .van-swipe-item{
                width: 100%;
                img{
                  width: 100%;
                  height: 200px;
                }
              }
            }
          }
        }
        //客户评价
        .evaluateline{
          width: 100%;
          height: 120px;
          background: #F9F9F9;
          border-radius: 10px;
          margin: 0 0 15px;
          padding: 10px;
          box-sizing: border-box;
          .top{
            display: flex;
            justify-content: flex-start;
           .headerpng{
             .hepng{
               width: 40px;
               height: 40px;
               margin-top:6px;
             }
           }
            .headerintro{
              margin-left: 12px;
              .name{
                height: 30px;
                font-size:14px;
                font-family: PingFang SC;
                font-weight: 600;
                color: #141414;
                line-height:30px;
              }
              .detail{
                font-size: 14px;
                font-family: PingFang SC;
                font-weight: 300;
                color: #666666;
              }
            }
          }
          .bottomss{
            line-height: 23px;
            font-size: 14px;
            font-family: PingFang SC;
            font-weight: 400;
            color: #141414;
            margin-top: 10px;
          }
        }
        //.lookmore{
        //
          .lookmorered{
            width: 100%;
            height: 40px;
            line-height: 40px;
            background: #F6F6F6;
            margin: 10px auto;
            font-size:15px;
            text-align: center;
            font-family: PingFang SC;
            font-weight: 300;
            color: #F8242C;
          }
          .lookmoregrey{
            width: 100%;
            height: 40px;
            line-height: 40px;
            background: #F6F6F6;
            margin: 10px auto;
            font-size:15px;
            text-align: center;
            font-family: PingFang SC;
            font-weight: 300;
            color: #999999;
          }
        //}
      }
    }
    .blackmodel{
      height: 341px;
      background: #26242F;
      text-align: center;
      position: relative;
      margin-bottom: 70px;
      .code1{
        height: 23px;
        font-size: 12px;
        font-family: PingFang SC;
        font-weight: 400;
        color: #6F6F79;
        line-height: 23px;
        padding-top: 25px;
      }
      .code2{
        height: 40px;
        font-size: 18px;
        font-family: PingFang SC;
        font-weight: 600;
        color: #FFFFFF;
        line-height: 40px;
      }
      .code3{
        height: 20px;
        font-size: 12px;
        font-family: PingFang SC;
        font-weight: 400;
        color: #6F6F79;
        line-height: 20px;
      }
      .code4{
        height: 20px;
        font-size: 12px;
        font-family: PingFang SC;
        font-weight: 400;
        color: #6F6F79;
        line-height: 20px;
      }
      .blackcode{
        padding:20px 70px;
        display: flex;
        justify-content: space-between;
        .codeline{
          .linpng{
           .codepng{
             width: 90px;
             height: 90px;
           }
          }
          .linword{
            height: 23px;
            font-size: 12px;
            font-family: PingFang SC;
            font-weight: 400;
            color: #6F6F79;
            line-height: 23px;
            padding: 4px 0;
          }
        }

      }
      .bot{
        height: 64px;
        background: #19181D;
        position: absolute;
        bottom: 0;
        width: 100%;
        p{
          height: 23px;
          font-size: 12px;
          font-family: PingFang SC;
          font-weight: 400;
          color: #6F6F79;
          line-height: 23px;
          &:nth-child(1){
            margin-top: 10px;
          }
        }
      }
    }
    .bottom{
      position: fixed;
      background: white;
      z-index: 6;
      width: 100%;
      bottom: 0;
      left: 0;
      height: 60px;
      display: flex;
      justify-content: space-between;
      .bottomleft{
        width: 65%;
        display: flex;
        justify-content: space-around;
        .bottombox{
          .b_top{
            .b_png{
              width: 28px;
              height: 28px;
              margin-top: 6px;
            }
          }
          .b_bottom{
            height: 20px;
            font-size: 13px;
            font-family: PingFang SC;
            font-weight: 400;
            color: #141414;
            line-height: 20px;
          }
        }
      }

      .joinbtn{
        height: 60px;
        background: #F8242C;
        font-size: 16px;
        font-family: PingFang SC;
        font-weight: 400;
        color: #FFFFFF;
        line-height: 60px;
        width: 120px;
        text-align: center;
      }
    }
  }
</style>
